export default function LakewoodRanchFinalCTA() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial+view+of+Lakewood+Ranch+Florida+master-planned+community+at+golden+sunset+with+golf+course+and+luxury+homes%2C+manicured+landscaping%2C+ponds+and+palm+trees%2C+warm+amber+and+emerald+light%2C+professional+drone+photography%2C+no+text+no+logos"
          alt="Lakewood Ranch Florida master-planned community at golden sunset"
          className="w-full h-full object-cover object-center"
          width={1600}
          height={600}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-8 text-center">
        <h2 className="font-serif text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
          Ready for Your Next Adventure From{" "}
          <span className="text-[#F6C344]">Lakewood Ranch, FL?</span>
        </h2>
        <p className="text-white/80 text-sm md:text-base leading-relaxed mb-10 max-w-xl mx-auto">
          Do not let an expired passport keep your child off their school trip to Europe,
          your foursome off the flight to St. Andrews, or your family off the cruise from Tampa.
          Start your application today and travel with confidence.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start My Application <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold text-base px-6 py-4 rounded-md transition-all backdrop-blur-sm whitespace-nowrap"
          >
            <i className="ri-phone-line text-[#F6C344]"></i> 877-253-0084
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 mt-10">
          {[
            { icon: "ri-shield-check-line", text: "Registered State Dept. Courier" },
            { icon: "ri-award-line", text: "A+ BBB Rating" },
            { icon: "ri-time-line", text: "24-Hour Emergency Processing" },
          ].map((badge, i) => (
            <div key={i} className="flex items-center gap-2 text-white/60 text-xs">
              <i className={`${badge.icon} text-[#F6C344]`}></i>
              <span>{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}